
<template>

<el-dialog title="商家信息" :visible.sync="visible" :before-close="handleClose" @close="hide" size="small">

    <form-template :id="id" @onCancel="onCancel" @onSubmit="onSubmit" ref="form-template" :formDefault="formDefault" selectInfoAction="selectBusinessInfo.action" editAction="updateBusiness.action" insertAction="insertBusiness.action" :rules="rules" module="business"
    :components="components">
    </form-template>

</el-dialog>

</template>

<script>

import BasicPager from '../../../mixins/BasicPager'
import BusinessModel from '../../../framework/models/businessModel'
import ChannelModel from '../../../framework/models/channelModel'
import sxbUserModel from '../../../framework/models/sxbUserModel'
import brandAndSeriesCascader from '../../../components/brandAndSeriesCascader'
import districtAndCountyCascader from '../../../components/districtAndCountyCascader'
import Config from '../../../framework/configs/Config'
import FormTemplate from '../../../components/FormTemplate'
export default {
  name: 'save-merchant-dialog',
  extends: BasicPager,
  data: function () {
    let validateAccount = (rule, value, callback) => {
      if (!value || this.id) {
        callback()
        return
      }
      let _this = this
      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          if (datas) {
            let info = {}
            info.businessName = datas.companyName
            info.areaCode = datas.locationIdPath
            info.address = datas.detailAddress
            info.abutmentPersonName = datas.userName
            info.abutmentPhone = datas.smsReceivingPhone
            _this.$refs['form-template'].bindData(info)
            // 设置地址
            let addrs = datas.address.split(',')
            let length = 0
            if (addrs && (length = addrs.length) > 3) {
              let natureData = {
                areaName: addrs[length - 3] + ' ' + addrs[length - 2] + ' ' + addrs[length - 1]
              }
              _this.$refs['form-template'].bindNatureData(natureData)
            }
            callback()
          } else {
            callback(new Error('不存在该车大神账号，请重新输入！'))
          }
        }
      }
      sxbUserModel.selectByAccountNumber(this, {
        accountNumber: value
      }, listener)
    }
    let validatePic = (rule, value, callback) => {
      if (!value) {
        callback(new Error('商家图片没能为空！'))
        return
      }
      if (value.length == 0) {
        callback(new Error('商家图片没能为空！'))
      } else {
        return callback()
      }
    }
    let validateBusiness = (rule, value, callback) => {
      if (!value) {
        callback()
        return
      }
      let _this = this
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas && _this.model === 'add') {
            callback(new Error('已存在该用户，请重新输入！'))
          } else {
            callback()
          }
        }
      }
      BusinessModel.checkExistsBusiness(this, {
        accountNumber: value
      }, listener)
    }
    return {
      id: null,
      formDefault: {
        createPerson: ''
      },
      rules: {
        businessCarMaster: [{
          validator: validateAccount,
          trigger: 'blur'
        }, {
          validator: validateBusiness,
          trigger: 'blur'
        }],
        location: [
          {
            required: true,
            message: '地图坐标不能为空！'
          }
        ],
        businessName: [{
          required: true,
          message: '商家名称不能为空'
        }],
        areaCode: [{
          required: true,
          message: '所属地区不能为空',
          trigger: 'change'
        }],
        address: [{
          required: true,
          message: '详细地址不能为空',
          trigger: 'change'
        }],
        serviceType: [{
          type: 'array',
          required: true,
          message: '服务类型不能为空',
          trigger: 'change'
        }],
        abutmentPersonName: [{
          required: true,
          message: '对接人姓名不能为空'
        }],
        abutmentPhone: [{
          required: true,
          message: '对接人电话不能为空'
        }],
        businessIcon: [{
          required: true,
          message: '商家图片不能为空',
          trigger: 'change',
          validator: validatePic
        }]
      },
      components: [{
        name: 'el-input',
        label: '车大神号',
        field: 'businessCarMaster',
        prop: {
          placeholder: '请输入关联车大神账号'
        }
      }, {
        name: 'el-input',
        label: '商家名称',
        field: 'businessName',
        prop: {
          placeholder: '请输入商家名称'
        }
      }, {
        name: 'component',
        label: '所属地区',
        field: 'areaCode',
        prop: {
          componentName: districtAndCountyCascader,
          dataAlias: [
            'areaCode',
            'areaName'
          ],
          placeholder: '请选择商家所属地区'
        }
      }, {
        name: 'el-input',
        label: '详细地址',
        field: 'address',
        prop: {
          placeholder: '请输入商家地址'
        }
      },
      {
        name: 'el-amap',
        label: '地图',
        field: 'location',
        prop: {
        }
      },
      {
        name: 'el-select',
        label: '服务类型',
        field: 'serviceType',
        prop: {
          filterable: 'filterable',
          allowCreate: false,
          multiple: true,
          placeholder: '请选择服务类型（多选）',
          options: [{
            label: '买车卖车',
            value: '买车卖车'
          }, {
            lable: '维修保养',
            value: '维修保养'
          }, {
            lable: '美容洗车',
            value: '美容洗车'
          }, {
            lable: '汽车租赁',
            value: '汽车租赁'
          }, {
            lable: '汽车配件',
            value: '汽车配件'
          }]
        }
      }, {
        name: 'el-input',
        label: '商家介绍',
        field: 'businessDesc',
        prop: {
          placeholder: '请简要描述商家（最多60汉字）比如：一车购，国内领先的专业汽车互联网代购平台，采用互联网+实体门店模式打造一站式购车体验，帮助用户实现轻松买车、省心用车。'
        }
      }, {
        name: 'el-select',
        label: '导流渠道',
        field: 'clueChannels',
        prop: {
          filterable: 'filterable',
          allowCreate: false,
          placeholder: '请选择要导流的渠道（多选）',
          options: [],
          optionsName: 'channelName',
          optionsValue: 'id',
          multiple: true,
          visible: true
        }
      }, {
        name: 'el-select',
        label: '展示渠道',
        field: 'showChannels',
        prop: {
          filterable: 'filterable',
          allowCreate: false,
          placeholder: '请选择要展示的渠道（多选）',
          options: [],
          optionsName: 'channelName',
          optionsValue: 'id',
          multiple: true,
          visible: true
        }
      }, {
        name: 'el-input',
        label: '对接人姓名',
        field: 'abutmentPersonName',
        prop: {
          span: 10,
          placeholder: '请输入姓名'
        }
      }, {
        name: 'el-input',
        label: '对接人电话',
        field: 'abutmentPhone',
        prop: {
          span: 10,
          placeholder: '请输入11位手机号'
        }
      }, {
        name: 'el-upload',
        label: '商家图片',
        field: 'businessIcon',
        prop: {
          floder: 'applyBusinessHeader'
        }
      }

      ],
      visible: false
    }
  },
  watch: {
    'formDialog.businessCarMaster': function (newValue) {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          if (_this.model != 'add' && _this.formDialog.businessCarMaster == _this.oldData.businessCarMaster) {
            return
          }
          if (dataInfo.datas) {
            let datas = dataInfo.datas
            let names = datas.address.split(',')
            _this.formDialog.address = datas.detailAddress
            _this.formDialog.businessName = datas.companyName
            _this.formDialog.areaCode = datas.locationIdPath
            _this.formDialog.abutmentPhone = datas.smsReceivingPhone
            _this.formDialog.abutmentPersonName = datas.userName
            if (_this.$refs['countyCascader']) {
              _this.$refs['countyCascader'].setAreaCode(datas.locationIdPath)
            }
            _this.formDialog.areaNamePlaceholder = names[names.length - 3] + ' ' + names[names.length - 2] + ' ' + names[names.length - 1]
            _this.formDialog.areaName = names[names.length - 3] + ' ' + names[names.length - 2] + ' ' + names[names.length - 1]
          }
        }
      }
      sxbUserModel.selectByAccountNumber(this, {
        accountNumber: newValue
      }, listener)
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.isChannel = userInfo.loginPath === 'channel'
    this.formDefault.createPerson = userInfo.realName
    // this.formDialog.showChannels=this.isChannel?[userInfo.id]:[]
    let loginInfo = this.loginInfo
    if (loginInfo.loginPath == 'channel') {
      this.components[0].prop.visible = false
      this.components[7].prop.visible = false
      this.components[8].prop.visible = false
      this.formDefault.showChannels = loginInfo.id
      this.formDefault.channelId = loginInfo.id
    } else {
      this.findAllChannels()
    }
  },
  methods: {
    onSubmit: function () {
      this.$emit('handleSuccess')
      this.hide()
    },
    onCancel: function () {
      this.hide()
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    handleAvatarSuccess (response, file, fileList) {
      this.formDialog.thumbnailUrl.push(response.datas)
      this.formDialog.thumbnailUrlStr = this.formDialog.thumbnailUrl.toString()
    },
    handleRemove (file, fileList) {
      this.formDialog.thumbnailUrl.pop(file.response.datas)
      this.formDialog.thumbnailUrlStr = this.formDialog.thumbnailUrl.toString()
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    onAreaChanged: function (areaCode, areaName) {
      this.formDialog.areaCode = areaCode[areaCode.length - 1]
      this.formDialog.areaName = areaName.join(' ')
    },
    handleClose (done) {
      let that = this
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
          that.$refs['form-template'].resetForm()
        })
        .catch(_ => {})
    },
    show: function (dataItem) {
      this.visible = true
      this.findAllChannels()
      if (dataItem) {
        this.id = dataItem.id
      }
    },
    hide: function () {
      let formTemplate = this.$refs['form-template']
      if (formTemplate) {
        this.$refs['form-template'].resetForm()
      }
      this.id = 0
      this.visible = false
    },
    findAllChannels: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.components[7].prop.options = dataInfo.datas
          _this.components[8].prop.options = dataInfo.datas
        }
      }
      ChannelModel.findAllChannels(_this, listener)
    }
  },
  components: {
    brandAndSeriesCascader,
    FormTemplate,
    districtAndCountyCascader
  }
}

</script>
